import axios from 'axios'
import Cookies from 'js-cookie'
import { handleNoAuth, toSSOLogin } from '@/api/utils'
import { isPrivate } from '@/config'
import { getToken } from '@/utils/auth'
import { errorInfo } from '@/utils/common'

const path="/stageNow"
// export  const baseURL = process.env.NODE_ENV === 'production'? window.location.origin+":8087" + path: path;
export  const baseURL = process.env.NODE_ENV === 'production'? window.location.origin + '/qcserver': path;

// export  const baseURL = "http://192.168.41.151/stageNow/";

const service = axios.create({
  baseURL:baseURL,
  timeout:600000 // request timeout
})

// 请求拦截器，携带token字段
service.interceptors.request.use( 
  config => {
    // 请求头携带token
    if (getToken()) {
      config.headers['stageNowToken'] = getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response
    // 没有权限 跳转到IOT页面
    if(response.data.errorCode == 'DA0301') return handleNoAuth(response.data);
    // 未登录 跳转到SSO登录
    if (['DA0200', 'DA0230', 'DA0231'].includes(response.data.errorCode) && response.config.url.indexOf('iot/beforeSSO') === -1 && !isPrivate) {
      Cookies.remove("JSESSIONID_StageNow");
      return toSSOLogin();
    }
    // 服务响应失败要做什么
    if (res.status!==200) {
      return Promise.reject(new Error(res.statusText || 'Error'))
    } else {
      return response.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
